import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import queryString from "query-string";
import TermsAndConditionsModal from "./Modal/TermsAndConditionsModal";
import AcceptableUseModal from "./Modal/AcceptableUseModal";
import PrivacyPolicyModal from "./Modal/PrivacyPolicyModal";
import CookiePolicyModal from "./Modal/CookiePolicyModal";
import ReportAnIssueModal from "./Modal/ReportAnIssueModal";
import TutorialModal from "./Modal/TutorialModal";
import { POLICY_TYPES } from "../utils/constants";

export function AuthFooter() {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showAcceptableUseModal, setShowAcceptableUseModal] = useState(false);
  const [showTermsAndConditionsModal, setShowTermsAndConditions] = useState(false);
  const [showReportAnIssueModal, setShowReportAnIssueModal] = useState(false);
  const [isTutorialModalOpen, setIsTutorialModalOpen] = useState(false);
  const [showCookiePolicyModal, setShowCookiePolicyModal] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const queryStrings = queryString.parse(location.search);
    const hasPrivacy = POLICY_TYPES.PRIVACY in queryStrings;
    const hasTermsAndConditions = POLICY_TYPES.TERMS_AND_CONDITIONS in queryStrings;
    const hasAcceptableUsePolicy = POLICY_TYPES.ACCEPTABLE_USE in queryStrings;
    const hasCookiePolicy = POLICY_TYPES.COOKIE in queryStrings;

    if (hasPrivacy) {
      setShowPrivacyModal(true);
    }

    if (hasAcceptableUsePolicy) {
      setShowAcceptableUseModal(true);
    }

    if (hasTermsAndConditions) {
      setShowTermsAndConditions(true);
    }

    if (hasCookiePolicy) {
      setShowCookiePolicyModal(true);
    }
  }, [location.search]);

  const openModal = (type: POLICY_TYPES) => {
    navigate(`${location.pathname}?${type}`);
  };

  const closeModal = (type: POLICY_TYPES) => {
    switch (type) {
      case POLICY_TYPES.ACCEPTABLE_USE:
        setShowAcceptableUseModal(false);
        break;
      case POLICY_TYPES.PRIVACY:
        setShowPrivacyModal(false);
        break;
      case POLICY_TYPES.TERMS_AND_CONDITIONS:
        setShowTermsAndConditions(false);
        break;
      case POLICY_TYPES.COOKIE:
        setShowCookiePolicyModal(false);
        break;
    }
    navigate(location.pathname, { replace: true });
  };

  const links = [
    { 
      label: 'Acceptable Use Policy', 
      onClick: () => openModal(POLICY_TYPES.ACCEPTABLE_USE)
    },
    { 
      label: 'Privacy Policy', 
      onClick: () => openModal(POLICY_TYPES.PRIVACY)
    },
    { 
      label: 'Terms and conditions', 
      onClick: () => openModal(POLICY_TYPES.TERMS_AND_CONDITIONS)
    },
    { 
      label: 'Report an issue', 
      onClick: () => setShowReportAnIssueModal(true)
    },
    { 
      label: 'Ignite Tutorials', 
      onClick: () => setIsTutorialModalOpen(true)
    },
    { 
      label: 'Cookie Policy', 
      onClick: () => openModal(POLICY_TYPES.COOKIE)
    }
  ];

  return (
    <>
      <footer className="mt-8 pt-6 border-t border-gray-200">
        <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-xs text-gray-600">
          {links.map((link, index) => (
            <span key={link.label} className="flex items-center gap-2">
              <a 
                onClick={(e) => {
                  e.preventDefault();
                  link.onClick();
                }}
                className="hover:text-orange-600 transition cursor-pointer"
              >
                {link.label}
              </a>
              {index < links.length - 1 && (
                <span className="text-gray-400">·</span>
              )}
            </span>
          ))}
        </div>
      </footer>

      <PrivacyPolicyModal
          isOpen={showPrivacyModal}
          onClose={() => closeModal(POLICY_TYPES.PRIVACY)}
        />
      <AcceptableUseModal
          isOpen={showAcceptableUseModal}
          onClose={() => closeModal(POLICY_TYPES.ACCEPTABLE_USE)}
        />
      <TermsAndConditionsModal
          isOpen={showTermsAndConditionsModal}
          onClose={() => closeModal(POLICY_TYPES.TERMS_AND_CONDITIONS)}
        />
      <ReportAnIssueModal
          isOpen={showReportAnIssueModal}
          onClose={() => setShowReportAnIssueModal(false)}
        />
      <TutorialModal
          isOpen={isTutorialModalOpen}
          onClose={() => setIsTutorialModalOpen(false)}
        />
      <CookiePolicyModal
          isOpen={showCookiePolicyModal}
          onClose={() => closeModal(POLICY_TYPES.COOKIE)}
        />
    </>
  );
}

